var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-tags-item",on:{"click":function($event){return _vm.close(_vm.item)}}},[_vm._t("default",[_c('div',{staticClass:"default"},[_vm._v(_vm._s(_vm.title)+"  х")])],null,_vm.item.Value)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd7604c6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-tags/src/ui-tags-item.vue
// module id = 743
// module chunks = 0